/* Cart availability checker
   Checks each cart item against per-location inventory and flags items
   that are unavailable at any fulfillment location. Runs automatically
   on the cart page.

   Include this in the theme layout or cart template:
   {{ 'cart-availability.js' | asset_url | script_tag }}
*/
(function () {
  'use strict';

  var PROXY = '/apps/membership';
  var CHECK_URL = PROXY + '/cart-check';

  /* Style for the warning banner and per-item flags */
  var STYLE_ID = 'cart-avail-css';
  if (!document.getElementById(STYLE_ID)) {
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent = [
      '.cart-avail-banner{background:#fef2f2;border:1px solid #f3c1c1;',
      'border-radius:8px;padding:16px 20px;margin-bottom:20px;font-size:14px;line-height:1.6}',
      '.cart-avail-banner b{display:block;margin-bottom:6px;color:#c0392b}',
      '.cart-avail-banner ul{margin:8px 0 0 18px;padding:0}',
      '.cart-avail-banner li{margin-bottom:4px;color:#1c1c1c}',
      '.cart-avail-banner li span{color:#7a7a78;font-size:12px}',
      '.cart-avail-flag{background:#fef2f2;border:1px solid #f3c1c1;',
      'border-radius:4px;padding:6px 10px;margin-top:6px;font-size:12px;color:#c0392b;',
      'display:inline-block}'
    ].join('\n');
    document.head.appendChild(css);
  }

  function run() {
    /* Read the cart via Shopify's AJAX API */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        var variantIds = cart.items.map(function (item) {
          return item.variant_id || item.id;
        });

        /* Build a map of variant_id -> cart line item info for flagging */
        var itemMap = {};
        cart.items.forEach(function (item) {
          itemMap[item.variant_id || item.id] = {
            title: item.product_title,
            variant: item.variant_title,
            key: item.key
          };
        });

        return fetch(CHECK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ variant_ids: variantIds })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data.unavailable || !data.unavailable.length) {
              removeBanner();
              return;
            }

            /* Only flag items that are actually in the cart */
            var flagged = data.unavailable.filter(function (u) {
              return variantIds.indexOf(u.variant_id) > -1;
            });

            if (!flagged.length) {
              removeBanner();
              return;
            }

            showBanner(flagged);
            flagLineItems(flagged);
          });
      })
      .catch(function (err) {
        console.warn('Cart availability check failed:', err);
      });
  }

  function removeBanner() {
    var existing = document.getElementById('cart-avail-banner');
    if (existing) existing.remove();
  }

  function showBanner(items) {
    removeBanner();

    var html = '<div id="cart-avail-banner" class="cart-avail-banner">'
      + '<b>Some items may not be available at your delivery location</b>'
      + '<ul>';

    items.forEach(function (item) {
      html += '<li><strong>' + esc(item.display_name) + '</strong>';
      if (item.missing_at && item.missing_at.length) {
        html += ' <span>— not in stock at ' + esc(item.missing_at.join(', ')) + '</span>';
      }
      html += '</li>';
    });

    html += '</ul>'
      + '<p style="margin:10px 0 0;font-size:13px;color:#7a7a78">'
      + 'Please remove the affected item(s) or choose an alternative to continue.</p>'
      + '</div>';

    /* Insert at the top of the cart form or cart container */
    var cart = document.querySelector('form[action="/cart"]')
      || document.querySelector('.cart')
      || document.querySelector('[data-cart]')
      || document.querySelector('#cart')
      || document.querySelector('.template-cart main')
      || document.querySelector('main');

    if (cart) {
      cart.insertAdjacentHTML('afterbegin', html);
    }
  }

  function flagLineItems(items) {
    /* Remove existing flags */
    document.querySelectorAll('.cart-avail-flag').forEach(function (el) {
      el.remove();
    });

    items.forEach(function (item) {
      /* Try to find the cart line item by variant ID or product title */
      var row = document.querySelector('[data-variant-id="' + item.variant_id + '"]')
        || document.querySelector('[data-id="' + item.variant_id + '"]')
        || findByTitle(item.product_title);

      if (row) {
        var flag = document.createElement('div');
        flag.className = 'cart-avail-flag';
        flag.textContent = 'Unavailable at '
          + (item.missing_at ? item.missing_at.join(', ') : 'your location');

        /* Insert after the product title within the line item */
        var titleEl = row.querySelector('.cart-item__name')
          || row.querySelector('.cart__product-title')
          || row.querySelector('a[href*="/products/"]')
          || row.querySelector('td:nth-child(2)')
          || row;
        titleEl.parentNode.insertBefore(flag, titleEl.nextSibling);
      }
    });
  }

  function findByTitle(title) {
    if (!title) return null;
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].textContent.trim().indexOf(title) > -1) {
        /* Walk up to the row container */
        var el = links[i];
        for (var j = 0; j < 5; j++) {
          el = el.parentElement;
          if (!el) break;
          if (el.tagName === 'TR' || el.classList.contains('cart-item')
            || el.classList.contains('cart__row')
            || el.getAttribute('data-cart-item') !== null) {
            return el;
          }
        }
        return links[i].closest('tr, [data-cart-item], .cart-item, .cart__row');
      }
    }
    return null;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  /* Run on page load, and re-run when the cart drawer updates */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Also re-run when cart items change (for AJAX carts / drawers) */
  var _origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    return _origFetch.apply(this, args).then(function (response) {
      if (url.indexOf('/cart/') > -1 && url.indexOf('cart-check') === -1) {
        setTimeout(run, 500);
      }
      return response;
    });
  };
})();
